import $ from "jquery";
import moment from "moment";
import Seed from "DMS/Seed/All";
import { initHome } from "DMS/Controllers/homeController";
import loadSite from "DMS/Utils/ePortail_dynMenu.js";
import { onWindowResize, resizeScreen } from "DMS/Utils/resizeScreen";
import * as requiredField from "DMS/Utils/requiredField";
import * as processLauncher from "DMS/Utils/processLauncher";
import { waitForFinalEvent } from "DMS/Controllers/commonController";
// @todo : ce serait bien de segmenter cette variable
let localisationWindow = null;
// @todo : Controller interface (POO)
// @todo : moduleType => enum
export function initializeCtrl() {
    try {
        var cultureMoment = localeMoment;
        moment.locale(cultureMoment);
    }
    catch (err) {
        cultureMoment = cultureMoment.split("-");
        cultureMoment = cultureMoment[0];
        moment.locale(cultureMoment);
    }
    // Broadcast that you're opening a page.
    localStorage.openpages = Date.now();
    $(window).resize(() => waitForFinalEvent(onWindowResize, 150, "some unique string"));
    // store a value indicating that the software is opened in another tab
    // (we won't disconnect the user by closing a tab if another tab containing the software is also opened)
    $(window).on('storage', function (event) {
        if (event.key == 'openpages') {
            localStorage.page_available = ('page_available' in localStorage ? parseInt(localStorage.page_available, 10) + 1 : '2');
        }
    });
    $(window).on('beforeunload', function (event) {
        if ('page_available' in localStorage) {
            localStorage.page_available = parseInt(localStorage.page_available, 10) - 1;
        }
        if ('page_available' in localStorage === false
            || localStorage.page_available == 0) {
            if ('page_available' in localStorage) {
                delete localStorage.page_available;
            }
            let urlDeconnexion = root + "php_bdd/disconnect.php";
            const formData = new FormData();
            formData.append("moduleType", moduleType);
            navigator.sendBeacon(urlDeconnexion, formData);
        }
    });
    $('#disconnect').on('click', function (event) {
        if ('page_available' in localStorage) {
            delete localStorage.page_available;
        }
        if (moduleType === "ePortail") {
            window.location = root + '../../EPortail';
        }
        else {
            window.location = root + '../';
        }
    });
    Seed.Menu.ShowModule("accueil");
    if (moduleType === "ePortail") {
        loadSite("");
    }
    else {
        initHome();
    }
}
export function showModule(nomModule, libModule, numAction, isDebug, isDefaultAction) {
    if (!requiredField.checkRequiredFieldInCurrentModule(Seed.Tab.CurrentModule, Seed.Tab.aActive[Seed.Tab.CurrentModule])) {
        return false;
    }
    Seed.Menu.ShowModule(nomModule, libModule, isDefaultAction);
    if (isDefaultAction !== true && numAction) {
        processLauncher.process(numAction, null, null, null, isDebug);
    }
    if (moduleType === "ServiceMaint" && nomModule === "accueil") {
        initHome();
    }
    if (isDefaultAction === true && Seed.Tab.aModule.indexOf(nomModule) === -1) {
        processLauncher.process(numAction, null, null, null, isDebug);
    }
    // indique qu'on change de module : utile pour afficher/masquer
    // la carte de geoloc
    $(document).trigger("dms:moduleChange", nomModule);
}
//****** Lancement action via ProcessLauncher
// @todo : est-ce qu'on a besoin de cette fonction ?
function Process(numaction, param, paramui, input, modeDebug, forceNoReload, forceNoRead, isImpr, selectedElem, isFromForm, event) {
    return processLauncher.process(numaction, param, paramui, input, modeDebug, forceNoReload, forceNoRead, isImpr, selectedElem, isFromForm, event);
}
// @todo : est-ce qu'on a besoin de cette fonction ?
function ProcessUpdate(pNomTable, pNomChampIndex, pIndex, pNomChamp, pNouvelleValeur, pImport, forceReload, origine, typechamp, param_multiselect_insert = false, updateOrigin = "form", secondPkNameForDefaultValue = '', param_multiselect_default = '') {
    processLauncher.processUpdate(pNomTable, pNomChampIndex, pIndex, pNomChamp, pNouvelleValeur, pImport, forceReload, origine, typechamp, param_multiselect_insert = false, updateOrigin = "form", secondPkNameForDefaultValue = '', param_multiselect_default = '');
}
// @todo : est-ce qu'on a besoin de cette fonction ?
function ProcessAction(sendrequest, input, forceNoReload, forceNoRead) {
    processLauncher.processAction(sendrequest, input, forceNoReload, forceNoRead);
}
export function ProcessPHP(URL, param, paramui, type, titre) {
    processLauncher.processPHP(URL, param, paramui, type, titre);
}
export function initializeAlert() {
    // Alertes
    if (typeof (EventSource) !== "undefined") {
        // Yes! Server-sent events support!
        // Some code.....
        var source = new EventSource("_module/Alerte/demo_sse.php?moduleType=" + moduleType);
        source.addEventListener('message', function (e) {
            var myObject = JSON.parse(e.data);
            for (var key in myObject) {
                var value = myObject[key];
                var module = $('#tdmainmenu').find("#" + key + '_alert');
                $(module).text(value);
            }
        }, false);
    }
    else {
        // Sorry! No server-sent events support..
        console.log("Sorry! No server-sent events support..");
    }
}
export function envoiMail(param, fromJS) {
    if (!param) {
        param = [];
    }
    if (!fromJS) {
        param = JSON.parse(param);
    }
    // etat
    var etat = $('#etatImpression').val();
    param["nometat"] = etat;
    // email
    var email = $('#mailDestinataire').val();
    param["destinataire"] = email;
    if (param['fromuser']) {
        param['fromuser'] = true;
    }
    else {
        param['fromuser'] = false;
    }
    if (param) {
        if (typeof param !== 'object') {
            var paramLength = param.length;
            for (var i = 0; i < paramLength; i++) {
                param[i][1] = parameter.decodeParam(param[i][1]);
                param[i][1] = encodeURIComponent(param[i][1]);
            }
        }
    }
    Seed.Ajax.Post({
        url: root + 'php_spec/envoimail.php',
        data: param,
        async: true,
        success: function (response) {
            var pTarget = $('#mailDestinataire').parents('#modalIframe')[0];
            var jscript = document.createElement("SCRIPT"); // BALISE SCRIPT
            jscript.text = response;
            pTarget.appendChild(jscript); // AJOUT DU SCRIPT AU DOCUMENT
        }
    });
}
//********* PanelController ? *****
export function initializePHPForm(nomtab, page, sImport) {
    if (nomtab) {
        Seed.Tab.AddTab();
        Seed.Tab.SetText(nomtab);
        Seed.Page.Load(page, sImport, true);
        Seed.Tab.SetCallback(function callb() {
            Seed.Page.Load(page, sImport, true);
        });
    }
    else {
        Seed.Page.Load(page, sImport, false);
    }
}
// Interface
export function showInterface(nomListe, label) {
    Seed.Interface.Init(nomListe);
    Seed.Tab.SetText(label);
    resizeScreen();
}
// Import
export function initializeImport(label) {
    Seed.Tab.SetText(label);
}
// ouverture de la geolocalisation
export function openLocalisation(arg) {
    if (typeof arg !== "undefined") {
        arg = '?origin=' + arg;
    }
    var url = "../source/_module/Geoloc/index.php" + arg;
    var target = "Localisation";
    // si on utilise google chrome
    if (navigator.userAgent.toLowerCase().indexOf('chrome') > -1 && navigator.vendor.toLowerCase().indexOf("google") > -1) {
        if (localisationWindow && !localisationWindow.closed) {
            localisationWindow.focus();
        }
        else {
            localisationWindow = open(url, target);
        }
    }
    else {
        if (localisationWindow && !localisationWindow.closed) {
            localisationWindow.close();
        }
        localisationWindow = open(url, target);
        return false;
    }
}
//# sourceMappingURL=eservicesController.js.map